import React from 'react'
import { bind } from '@src/utils'
import Main from '@src/components/main'
import SearchBar from '@src/components/search-bar'
import Table from '@src/components/table'
import * as ReactIcons from '@src/lib/react-icons'
import { titleMap, headerMap, fieldOrderMap } from './config'
import { SystemViewModel, ISystemViewModel } from './system.view-model'
import './style.scss'

function SystemManagement({
  category,
  keyword,
  currentPage,
  systemData,
  handleNextOnClick,
  handlePrevOnClick,
  handleMoveToOnClick,
  handleKeywordOnChange,
  handleSearchClick,
  handleAddBtnOnClick,
  handleEditBtnOnClick,
  handleDelBtnOnClick
}: ISystemViewModel) {
  const title = titleMap[category]
  return (
    <Main pageTitle={title}>
      <div className='setting'>
        <div className='search-bar-wrap'>
          <SearchBar
            value={keyword}
            handleOnChange={handleKeywordOnChange}
            handleOnClick={handleSearchClick}
          />
          {
            category !== 'api-logs' && <button className='plus-btn' onClick={handleAddBtnOnClick}>
              <ReactIcons.FaPlus className='plus-icon' />
              <span>新增</span>
            </button>
          }
        </div>
        {
          systemData?.data && <Table
            header={headerMap[category]}
            fieldOrder={fieldOrderMap[category]}
            data={systemData.data}
            totalNumber={systemData.totalNumber}
            totalPages={systemData.totalPages}
            currentPage={currentPage}
            prevOnClick={handlePrevOnClick}
            nextOnClick={handleNextOnClick}
            moveToOnClick={handleMoveToOnClick}
            editOnClick={category !== 'api-logs' ? handleEditBtnOnClick : undefined}
            delOnClick={category !== 'api-logs' ? handleDelBtnOnClick : undefined}
          />
        }
      </div>
    </Main>
  );
};

export default bind(SystemManagement, SystemViewModel)
